// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q15wp","type":"styles_type__73ScB","choices":"styles_choices__39Ru7"};